// import { debug, error, warn } from '@/libs/teco/Console'
import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import ui from '@/store/uiControll'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import getCsrfToken from '@/store/Csrf'
import { router } from '@/main.js'
import { commonUtil } from '@/util'
import { i18n } from '@/main.js'

const state = {
  auth: {
    isLogined: true
  },
  mailVerifyUrl: ''
}
const mutations = {
  [mutationsTypes.AUTH_SET_LOGIN]: (state, payload) => {
    // showConsole &&
    //   debug(`${CLASS_NAME}.${mutationsTypes.AUTH_SET_LOGIN}()`, {
    //     ...payload
    //   })
    state.auth.isLogined = payload.isLogined
  },
  [mutationsTypes.AUTH_SET_MAIL_VERIFY_URL]: (state, payload) => {
    state.mailVerifyUrl = payload.mailVerifyUrl
  }
}
const actions = {
  // LOG01 ログイン
  login: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const isLogined = await axios
      .post(api.LOGIN, params)
      // .get(apiMock.LOGIN, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return isLogined
  },
  // メール認証時のrequestUrl実行用
  requestMailVerify: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    const instance = axios.create()
    instance.defaults.params = {}
    const ret = await instance
      .get(getters.mailVerifyUrl)
      // .get(apiMock.MAIL_VERIFY)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // 403エラー出たら「LOG02 メール認証再送信」を暫定的に実行
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // LOG03 ログアウト
  logout: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    await getCsrfToken()
    return await axios
      .post(api.LOGOUT)
      // .get(apiMock.LOGOUT)
      .then((response) => {
        alert(i18n.tc('auth.login_logout-comp'))
        router.push({ name: 'Login' }).catch(() => {})
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // LOG02 メール認証再送信
  mailVerifyResend: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    await getCsrfToken()
    return await axios
      .post(api.MAIL_VERIFY_RESEND)
      // .get(apiMock.MAIL_VERIFY_RESEND)
      .then((response) => {
        alert(`認証メール再送信完了しました。
ご登録のメールをご確認ください。`)
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}
const getters = {
  authStatus: (state) => {
    return state.auth
  },
  mailVerifyUrl: (state) => {
    return state.mailVerifyUrl
  }
}

const AuthStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default AuthStore
